import React, { useState } from 'react';
import { Search, Calendar, DollarSign } from 'lucide-react';
import { format } from 'date-fns';
import { ptBR } from 'date-fns/locale';

export default function NegotiationSelector({ negotiations, selectedNegotiation, onSelect }) {
  const [searchTerm, setSearchTerm] = useState('');

  const filteredNegotiations = negotiations?.filter(neg => 
    neg?.title?.toLowerCase()?.includes(searchTerm?.toLowerCase()) ||
    neg?.clientName?.toLowerCase()?.includes(searchTerm?.toLowerCase()) ||
    neg?.destination?.toLowerCase()?.includes(searchTerm?.toLowerCase())
  );

  const getStatusBadge = (status) => {
    const statusConfig = {
      paid: { bg: 'bg-green-100', text: 'text-green-800', label: 'Pago' },
      partial: { bg: 'bg-yellow-100', text: 'text-yellow-800', label: 'Parcial' },
      pending: { bg: 'bg-blue-100', text: 'text-blue-800', label: 'Pendente' },
      overdue: { bg: 'bg-red-100', text: 'text-red-800', label: 'Atrasado' }
    };

    const config = statusConfig?.[status] || statusConfig?.pending;

    return (
      <span className={`${config?.bg} ${config?.text} px-2 py-1 rounded text-xs font-medium`}>
        {config?.label}
      </span>
    );
  };

  return (
    <div className="h-full flex flex-col">
      {/* Search */}
      <div className="p-4 border-b border-gray-200">
        <div className="relative">
          <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" size={18} />
          <input
            type="text"
            placeholder="Buscar negociação..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e?.target?.value)}
            className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
          />
        </div>
      </div>
      {/* Negotiation List */}
      <div className="flex-1 overflow-y-auto">
        {filteredNegotiations?.length === 0 ? (
          <div className="p-4 text-center text-gray-500">
            Nenhuma negociação encontrada
          </div>
        ) : (
          filteredNegotiations?.map((negotiation) => (
            <div
              key={negotiation?.id}
              onClick={() => onSelect(negotiation)}
              className={`p-4 border-b border-gray-200 cursor-pointer transition-colors ${
                selectedNegotiation?.id === negotiation?.id
                  ? 'bg-blue-50 border-l-4 border-l-blue-600' :'hover:bg-gray-50'
              }`}
            >
              <div className="flex items-start justify-between mb-2">
                <h3 className="font-semibold text-gray-900 text-sm line-clamp-2">
                  {negotiation?.title}
                </h3>
                {getStatusBadge(negotiation?.paymentStatus)}
              </div>

              <p className="text-xs text-gray-600 mb-2">
                Cliente: {negotiation?.clientName}
              </p>

              {negotiation?.destination && (
                <p className="text-xs text-gray-500 mb-2">
                  Destino: {negotiation?.destination}
                </p>
              )}

              <div className="flex items-center justify-between text-xs text-gray-500">
                <div className="flex items-center gap-1">
                  <Calendar size={14} />
                  {format(new Date(negotiation.saleDate), 'dd/MM/yyyy', { locale: ptBR })}
                </div>
                <div className="flex items-center gap-1 font-semibold text-gray-700">
                  <DollarSign size={14} />
                  {parseFloat(negotiation?.saleValue)?.toLocaleString('pt-BR', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                  })}
                </div>
              </div>

              <div className="mt-2 text-xs text-gray-600">
                {negotiation?.receivables?.length || 0} pagamento(s)
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
}